import React from 'react';
import { CreditCard, Filter, Search, UserCheck, Mail, Phone, FileText, AlertCircle, Percent, Info, SlidersHorizontal } from 'lucide-react';

export default function ReceiptsTab({
  recebimentosViewMode,
  setRecebimentosViewMode,
  cronogramaSearchTerm,
  setCronogramaSearchTerm,
  sidebarStatusFilter,
  setSidebarStatusFilter,
  sidebarRoomFilter,
  setSidebarRoomFilter,
  sidebarPropFilter,
  setSidebarPropFilter,
  PROPRIEDADES,
  filteredStaysForTimeline,
  receipts,
  selectedInquilinoId,
  setSelectedInquilinoId,
  currentInquilinoStay,
  isTenantPanelExpanded,
  setIsTenantPanelExpanded,
  setEditFormData,
  setEditingId,
  currentInquilinoTranches,
  formatMonthPt,
  formatDateToPt,
  filterType,
  setFilterType,
  activeMonth,
  setActiveMonth,
  paymentStatusFilter,
  setPaymentStatusFilter,
  listFaturacaoFilter,
  setListFaturacaoFilter,
  totalEsperadoMesFiltrado,
  totalPagoMesFiltrado,
  totalFaltaMesFiltrado,
  filteredReceiptsList,
  focarInquilinoNaTimeline,
  setQuickReceiptData
}) {
  return (
    <div className="space-y-6 animate-fadeIn">
      <div className="bg-white p-5 rounded-2xl shadow-sm border border-slate-200 flex flex-col lg:flex-row justify-between items-start lg:items-center gap-4">
        <div>
          <h2 className="text-xl font-extrabold text-slate-900 flex items-center gap-2">
            <CreditCard className="h-6 w-6" /> Gestão Avançada de Recebimentos por Tranches
          </h2>
        </div>
        <div className="flex bg-slate-100 p-1 rounded-xl border border-slate-200">
          <button
            onClick={() => setRecebimentosViewMode("timeline")}
            className={`px-3.5 py-2 rounded-lg text-xs font-bold ${
              recebimentosViewMode === "timeline" ? "bg-white text-slate-900 shadow-sm" : "text-slate-600"
            }`}
          >
            Cronograma por Inquilino
          </button>
          <button
            onClick={() => setRecebimentosViewMode("lista-geral")}
            className={`px-3.5 py-2 rounded-lg text-xs font-bold ${
              recebimentosViewMode === "lista-geral" ? "bg-white text-slate-900 shadow-sm" : "text-slate-600"
            }`}
          >
            Lista Geral de Tranches
          </button>
        </div>
      </div>

      {recebimentosViewMode === "timeline" && (
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          <div className="bg-white p-4 rounded-2xl shadow-sm border border-slate-200 space-y-4">
            <div className="space-y-1">
              <h3 className="font-extrabold text-[10px] text-slate-400 uppercase tracking-wider flex items-center gap-1">
                <Filter size={12} /> Filtros de Pesquisa
              </h3>
              <div className="relative mt-2">
                <Search className="absolute left-3 top-2.5 h-3.5 w-3.5 text-slate-400" />
                <input
                  type="text"
                  placeholder="Pesquisar por nome..."
                  value={cronogramaSearchTerm}
                  onChange={(e) => setCronogramaSearchTerm(e.target.value)}
                  className="pl-9 pr-3 py-1.5 w-full bg-slate-50 border border-slate-200 rounded-xl text-xs focus:outline-none"
                />
              </div>
              <div className="mt-2">
                <label className="text-[9px] font-bold uppercase text-slate-400 block mb-0.5">Estado</label>
                <select
                  value={sidebarStatusFilter}
                  onChange={(e) => setSidebarStatusFilter(e.target.value)}
                  className="w-full bg-slate-50 border border-slate-200 rounded-xl px-2.5 py-1.5 text-xs text-slate-700"
                >
                  <option value="Todos">Todos</option>
                  <option value="Ativo">Ativo (A habitar)</option>
                  <option value="Reservado">Reservado</option>
                  <option value="Concluído">Concluído</option>
                </select>
              </div>
              <div className="mt-2">
                <label className="text-[9px] font-bold uppercase text-slate-400 block mb-0.5">Quarto / ID</label>
                <input
                  type="text"
                  placeholder="Ex: Quarto 1"
                  value={sidebarRoomFilter}
                  onChange={(e) => setSidebarRoomFilter(e.target.value)}
                  className="px-3 py-1.5 w-full bg-slate-50 border border-slate-200 rounded-xl text-xs focus:outline-none text-slate-800"
                />
              </div>
              <div className="mt-2">
                <label className="text-[9px] font-bold uppercase text-slate-400 block mb-0.5">Apartamento</label>
                <select
                  value={sidebarPropFilter}
                  onChange={(e) => setSidebarPropFilter(e.target.value)}
                  className="w-full bg-slate-50 border border-slate-200 rounded-xl px-2.5 py-1.5 text-xs text-slate-700"
                >
                  <option value="Todos">Todos os Apartamentos</option>
                  {PROPRIEDADES.map((p) => (
                    <option key={p} value={p}>{p}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="space-y-2 max-h-[300px] overflow-y-auto pt-2 border-t border-slate-100">
              {filteredStaysForTimeline.map((stay) => {
                const tranches = receipts.filter((r) => r.stayId === stay.id);
                const pagas = tranches.filter((t) => t.status === "Pago").length;
                const total = tranches.length;
                const isSelected = selectedInquilinoId === stay.id;

                return (
                  <div
                    key={stay.id}
                    onClick={() => setSelectedInquilinoId(stay.id)}
                    className={`p-3 rounded-xl border cursor-pointer flex justify-between items-center transition-all ${
                      isSelected
                        ? "bg-slate-900 text-white border-slate-900 shadow-md font-black"
                        : "bg-slate-50 hover:bg-slate-100 border-slate-200 font-semibold"
                    }`}
                  >
                    <div>
                      <div className="flex items-center gap-1.5">
                        <span
                          className={`w-2 h-2 rounded-full ${
                            stay.status === "Ativo" ? "bg-emerald-500" : "bg-blue-400"
                          }`}
                        ></span>
                        <p className="text-xs truncate max-w-[110px]">{stay.inquilino}</p>
                      </div>
                      <p className={`text-[10px] mt-0.5 pl-3.5 ${isSelected ? "text-slate-300" : "text-slate-400"}`}>
                        {stay.propriedade} • {stay.quarto}
                      </p>
                    </div>
                    <span className={`text-[9px] font-black px-1.5 py-0.5 rounded ${isSelected ? "bg-slate-800 text-slate-100" : "bg-slate-200 text-slate-700"}`}>
                      {pagas}/{total}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="lg:col-span-3 grid grid-cols-1 lg:grid-cols-3 gap-6 items-start">
            {currentInquilinoStay && isTenantPanelExpanded && (
              <div className="bg-white p-5 rounded-2xl shadow-sm border border-slate-200 space-y-4 h-fit animate-scaleUp lg:col-span-1">
                <div className="flex justify-between items-center border-b pb-2">
                  <h3 className="font-extrabold text-[11px] text-indigo-900 uppercase flex items-center gap-1">
                    <UserCheck size={14} /> Ficha de Inquilino Coolivin
                  </h3>
                  <button
                    type="button"
                    onClick={() => setIsTenantPanelExpanded(false)}
                    className="text-slate-400 hover:text-black bg-slate-50 p-1 rounded transition-colors text-xs"
                  >
                    ✕
                  </button>
                </div>
                <div className="space-y-3 text-[11px] text-slate-600">
                  <div className="flex items-center gap-2">
                    <Mail size={13} className="text-slate-400" />
                    <span className="truncate">{currentInquilinoStay.email}</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <Phone size={13} className="text-slate-400" />
                    <span>{currentInquilinoStay.telemovel}</span>
                  </div>
                  <div className="grid grid-cols-2 gap-2 border-t pt-2">
                    <div>
                      <p className="text-[8px] text-slate-400 font-bold uppercase">Nacionalidade</p>
                      <p className="font-extrabold text-slate-800">{currentInquilinoStay.nacionalidade}</p>
                    </div>
                    <div>
                      <p className="text-[8px] text-slate-400 font-bold uppercase">Idade</p>
                      <p className="font-extrabold text-slate-800">{currentInquilinoStay.idade || "N/A"} anos</p>
                    </div>
                  </div>
                  <div className="border-t pt-2">
                    <p className="text-[8px] text-slate-400 font-bold uppercase">Despesas Comuns</p>
                    <p className="font-extrabold text-slate-800">€ {currentInquilinoStay.despesasComuns || 45}/mês</p>
                  </div>
                  <button
                    onClick={() => {
                      setEditFormData({ ...currentInquilinoStay });
                      setEditingId(currentInquilinoStay.id);
                    }}
                    className="w-full bg-slate-950 text-white font-bold py-2.5 rounded-xl text-[10px] mt-2 transition-all block text-center shadow-sm"
                  >
                    Editar Ficha Inquilino
                  </button>
                </div>
              </div>
            )}

            <div className={`${isTenantPanelExpanded ? "lg:col-span-2" : "lg:col-span-3"} bg-white p-6 rounded-2xl shadow-sm border border-slate-200 space-y-6 transition-all`}>
              <div className="flex justify-between items-start border-b pb-4 flex-wrap gap-2">
                <div>
                  <div className="flex items-center gap-2">
                    <span className="text-[9px] font-black bg-slate-100 text-slate-900 px-2.5 py-1 rounded-md uppercase tracking-wider">
                      {currentInquilinoStay?.propriedade}
                    </span>
                    {isTenantPanelExpanded ? (
                      <button
                        type="button"
                        onClick={() => setIsTenantPanelExpanded(false)}
                        className="text-[9px] font-bold bg-indigo-100 text-indigo-700 px-2.5 py-1 rounded transition-all"
                      >
                        Largar Cartões
                      </button>
                    ) : (
                      <button
                        type="button"
                        onClick={() => setIsTenantPanelExpanded(true)}
                        className="text-[9px] font-bold bg-slate-100 hover:bg-slate-200 px-2.5 py-1 rounded transition-all"
                      >
                        Mostrar Detalhes
                      </button>
                    )}
                  </div>
                  <h3 className="text-lg font-black text-slate-900 mt-2">{currentInquilinoStay?.inquilino}</h3>
                  <p className="text-xs text-slate-500 font-medium">
                    Contrato Financeiro: <strong className="text-slate-700">{formatDateToPt(currentInquilinoStay?.checkIn)}</strong> a <strong className="text-slate-700">{formatDateToPt(currentInquilinoStay?.checkOut)}</strong>
                  </p>
                </div>
                <div className="text-right">
                  <p className="text-xs text-slate-400 font-bold uppercase">Renda Base</p>
                  <p className="text-xl font-black text-slate-955">
                    {currentInquilinoStay?.renda}€<span className="text-xs font-normal text-slate-400">/mês</span>
                  </p>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {/* Reserva */}
                <div className="space-y-3">
                  <div className="bg-emerald-50 text-emerald-800 p-3 rounded-xl border text-center font-bold text-[10px]">DEVIDO COM A RESERVA</div>
                  {currentInquilinoTranches
                    .filter((t) => t.corFase === "verde")
                    .map((tranche) => (
                      <div key={tranche.id} className="bg-white border border-slate-200 rounded-2xl p-4 shadow-sm relative overflow-hidden space-y-3">
                        <div className="absolute top-0 left-0 bottom-0 w-1.5 bg-emerald-500"></div>
                        <div className="flex justify-between items-start">
                          <span className="text-[9px] font-black px-2 py-0.5 rounded bg-emerald-100 text-emerald-800 uppercase tracking-wider">{tranche.status}</span>
                        </div>
                        <h5 className="font-extrabold text-slate-955 text-xs tracking-tight">{tranche.titulo}</h5>
                        <p className="text-[10px] text-slate-400 font-medium leading-tight">{tranche.descricao}</p>
                        {tranche.refFatura ? (
                          <div className="flex items-center gap-1.5 bg-slate-50 border border-slate-100 text-slate-500 px-2 py-1 rounded font-mono text-[9px]">
                            <FileText size={11} className="text-indigo-500" /> Ref: {tranche.refFatura}
                          </div>
                        ) : (
                          <div className="flex items-center gap-1.5 bg-slate-50 border border-slate-100 text-slate-300 px-2 py-1 rounded italic text-[9px]"><FileText size={11} /> Sem Fatura</div>
                        )}
                        {tranche.isPlatformGap && (
                          <div className="bg-red-50 text-red-700 border border-red-100 rounded-xl p-2 text-[9px] font-bold flex items-center gap-1.5">
                            <AlertCircle size={12} className="text-red-500 flex-shrink-0" />
                            <span>Sem despesas de {tranche.despesasComunsValor || 45}€ (Plataforma)</span>
                          </div>
                        )}
                        {tranche.isPlatformCommissionDeducted && tranche.comissaoRetida > 0 && (
                          <div className="bg-red-50 text-red-700 border border-red-100 rounded-xl p-2 text-[9px] font-bold flex items-center gap-1.5">
                            <Percent size={12} className="text-red-500 flex-shrink-0" />
                            <span>Comissão Retida: {tranche.comissaoRetida.toFixed(2)}€</span>
                          </div>
                        )}
                        {tranche.notas && (
                          <div className="bg-slate-50 border border-slate-100 rounded-xl p-2 text-[9px] font-semibold text-slate-600 leading-relaxed"><strong>Obs:</strong> {tranche.notas}</div>
                        )}
                        <div className="grid grid-cols-2 gap-2 pt-2 border-t border-slate-100 text-[10px]">
                          <div className="space-y-1">
                            <p className="text-[8px] text-slate-400 font-bold uppercase font-black">Mês Cobrança</p>
                            <p className="font-bold text-slate-800">{formatMonthPt(tranche.mesVencimento)}</p>
                            <p className="text-[8px] text-slate-400 font-bold uppercase font-black">Renda Alvo</p>
                            <p className="font-bold text-slate-500">{formatMonthPt(tranche.mesReferencia)}</p>
                            <p className="text-[8px] text-slate-400 font-bold uppercase font-black">Prazo</p>
                            <p className="font-bold text-red-600">{formatDateToPt(tranche.dataLimite)}</p>
                          </div>
                          <div className="text-right flex flex-col justify-between items-end">
                            <div>
                              <p className="text-[8px] text-slate-400 font-bold uppercase tracking-wider">Devido</p>
                              <p className="text-xs font-black text-slate-900">{tranche.valorDevido.toFixed(2)}€</p>
                            </div>
                            <div className="mt-1">
                              <p className="text-[8px] text-emerald-600 font-bold uppercase tracking-wider">Recebido</p>
                              <p className="text-xs font-black text-emerald-600 bg-emerald-50 px-1.5 py-0.5 rounded">{tranche.valorRecebido.toFixed(2)}€</p>
                            </div>
                          </div>
                        </div>
                        <button
                          onClick={() => setQuickReceiptData({
                            ...tranche,
                            valorRecebido: tranche.valorRecebido || tranche.valorDevido,
                            dataRecebimento: tranche.dataRecebimento || new Date().toISOString().slice(0, 10),
                            metodo: tranche.metodo || "Transferência",
                            refFatura: tranche.refFatura || "",
                            notas: tranche.notas || "",
                          })}
                          className="w-full py-2 bg-slate-100 border border-slate-200 text-slate-700 font-bold text-[10px] rounded-xl hover:bg-slate-200 transition-colors"
                        >
                          EDITAR
                        </button>
                      </div>
                    ))}
                </div>

                {/* Check-In */}
                <div className="space-y-3">
                  <div className="bg-amber-50 text-amber-800 p-3 rounded-xl border text-center font-bold text-[10px]">DEVIDO NO CHECK-IN</div>
                  {currentInquilinoTranches
                    .filter((t) => t.corFase === "amarelo")
                    .map((tranche) => (
                      <div key={tranche.id} className="bg-white border border-slate-200 rounded-2xl p-4 shadow-sm relative overflow-hidden space-y-3">
                        <div className="absolute top-0 left-0 bottom-0 w-1.5 bg-amber-400"></div>
                        <div className="flex justify-between items-start">
                          <span className="text-[9px] font-black px-2 py-0.5 rounded bg-emerald-100 text-emerald-800 uppercase tracking-wider">{tranche.status}</span>
                        </div>
                        <h5 className="font-bold text-slate-955 text-xs tracking-tight">{tranche.titulo}</h5>
                        <p className="text-[10px] text-slate-400 font-medium leading-tight">{tranche.descricao}</p>
                        {tranche.refFatura ? (
                          <div className="flex items-center gap-1.5 bg-slate-50 border border-slate-100 text-slate-500 px-2 py-1 rounded font-mono text-[9px]">
                            <FileText size={11} className="text-indigo-500" /> Ref: {tranche.refFatura}
                          </div>
                        ) : (
                          <div className="flex items-center gap-1.5 bg-slate-50 border border-slate-100 text-slate-300 px-2 py-1 rounded italic text-[9px]"><FileText size={11} /> Sem Fatura</div>
                        )}
                        {tranche.isPlatformGapRecovered && (
                          <div className="bg-blue-50 text-blue-700 border border-blue-100 rounded-xl p-2 text-[9px] font-bold flex items-center gap-1.5">
                            <Info size={12} className="text-blue-500 flex-shrink-0" />
                            <span>Acerto de Despesas (+{tranche.despesasComunsValor || 45}€)</span>
                          </div>
                        )}
                        {tranche.notas && (
                          <div className="bg-slate-50 border border-slate-100 rounded-xl p-2 text-[9px] font-semibold text-slate-600 leading-relaxed"><strong>Obs:</strong> {tranche.notas}</div>
                        )}
                        <div className="grid grid-cols-2 gap-2 pt-2 border-t border-slate-100 text-[10px]">
                          <div className="space-y-1">
                            <p className="text-[8px] text-slate-400 font-bold uppercase font-black">Mês Cobrança</p>
                            <p className="font-bold text-slate-800">{formatMonthPt(tranche.mesVencimento)}</p>
                            <p className="text-[8px] text-slate-400 font-bold uppercase font-black">Renda Alvo</p>
                            <p className="font-bold text-slate-500">{formatMonthPt(tranche.mesReferencia)}</p>
                            <p className="text-[8px] text-slate-400 font-bold uppercase font-black">Prazo</p>
                            <p className="font-bold text-red-600">{formatDateToPt(tranche.dataLimite)}</p>
                          </div>
                          <div className="text-right flex flex-col justify-between items-end">
                            <div>
                              <p className="text-[8px] text-slate-400 font-bold uppercase tracking-wider">Devido</p>
                              <p className="text-xs font-black text-slate-900">{tranche.valorDevido.toFixed(2)}€</p>
                            </div>
                            <div className="mt-1">
                              <p className="text-[8px] text-emerald-600 font-bold uppercase tracking-wider">Recebido</p>
                              <p className="text-xs font-black text-emerald-600 bg-emerald-50 px-1.5 py-0.5 rounded">{tranche.valorRecebido.toFixed(2)}€</p>
                            </div>
                          </div>
                        </div>
                        <button
                          onClick={() => setQuickReceiptData({
                            ...tranche,
                            valorRecebido: tranche.valorRecebido || tranche.valorDevido,
                            dataRecebimento: tranche.dataRecebimento || new Date().toISOString().slice(0, 10),
                            metodo: tranche.metodo || "Transferência",
                            refFatura: tranche.refFatura || "",
                            notas: tranche.notas || "",
                          })}
                          className="w-full py-2 bg-slate-100 border border-slate-200 text-slate-700 font-bold text-[10px] rounded-xl hover:bg-slate-200 transition-colors"
                        >
                          EDITAR
                        </button>
                      </div>
                    ))}
                </div>

                {/* Mensalidades */}
                <div className="space-y-3">
                  <div className="bg-blue-50 text-blue-800 p-3 rounded-xl border text-center font-bold text-[10px]">DEVIDO FIM DO MÊS ANTERIOR</div>
                  {currentInquilinoTranches
                    .filter((t) => t.corFase === "azul")
                    .map((tranche) => (
                      <div key={tranche.id} className="bg-white border border-slate-200 rounded-2xl p-4 shadow-sm relative overflow-hidden space-y-3">
                        <div className="absolute top-0 left-0 bottom-0 w-1.5 bg-blue-500"></div>
                        <div className="flex justify-between items-start">
                          <span className="text-[9px] font-black px-2 py-0.5 rounded bg-emerald-100 text-emerald-800 uppercase tracking-wider">{tranche.status}</span>
                        </div>
                        <h5 className="font-bold text-slate-955 text-xs tracking-tight">{tranche.titulo}</h5>
                        <p className="text-[10px] text-slate-400 font-medium leading-tight">{tranche.descricao}</p>
                        {tranche.refFatura ? (
                          <div className="flex items-center gap-1.5 bg-slate-50 border border-slate-100 text-slate-500 px-2 py-1 rounded font-mono text-[9px]">
                            <FileText size={11} className="text-indigo-500" /> Ref: {tranche.refFatura}
                          </div>
                        ) : (
                          <div className="flex items-center gap-1.5 bg-slate-50 border border-slate-100 text-slate-300 px-2 py-1 rounded italic text-[9px]"><FileText size={11} /> Sem Fatura</div>
                        )}
                        {tranche.notas && (
                          <div className="bg-slate-50 border border-slate-100 rounded-xl p-2 text-[9px] font-semibold text-slate-600 leading-relaxed"><strong>Obs:</strong> {tranche.notas}</div>
                        )}
                        <div className="grid grid-cols-2 gap-2 pt-2 border-t border-slate-100 text-[10px]">
                          <div className="space-y-1">
                            <p className="text-[8px] text-slate-400 font-bold uppercase font-black">Mês Cobrança</p>
                            <p className="font-bold text-slate-800">{formatMonthPt(tranche.mesVencimento)}</p>
                            <p className="text-[8px] text-slate-400 font-bold uppercase font-black">Mês de Referência</p>
                            <p className="font-bold text-slate-500">{formatMonthPt(tranche.mesReferencia)}</p>
                            <p className="text-[8px] text-slate-400 font-bold uppercase font-black">Prazo</p>
                            <p className="font-bold text-red-600">{formatDateToPt(tranche.dataLimite)}</p>
                          </div>
                          <div className="text-right flex flex-col justify-between items-end">
                            <div>
                              <p className="text-[8px] text-slate-400 font-bold uppercase tracking-wider">Devido</p>
                              <p className="text-xs font-black text-slate-900">{tranche.valorDevido.toFixed(2)}€</p>
                            </div>
                            <div className="mt-1">
                              <p className="text-[8px] text-emerald-600 font-bold uppercase tracking-wider">Recebido</p>
                              <p className="text-xs font-black text-emerald-600 bg-emerald-50 px-1.5 py-0.5 rounded">{tranche.valorRecebido.toFixed(2)}€</p>
                            </div>
                          </div>
                        </div>
                        <button
                          onClick={() => setQuickReceiptData({
                            ...tranche,
                            valorRecebido: tranche.valorRecebido || tranche.valorDevido,
                            dataRecebimento: tranche.dataRecebimento || new Date().toISOString().slice(0, 10),
                            metodo: tranche.metodo || "Transferência",
                            refFatura: tranche.refFatura || "",
                            notas: tranche.notas || "",
                          })}
                          className="w-full py-2 bg-slate-900 text-white font-bold text-[10px] rounded-xl hover:bg-slate-200 transition-colors"
                        >
                          EDITAR
                        </button>
                      </div>
                    ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {recebimentosViewMode === "lista-geral" && (
        <div className="space-y-6 animate-fadeIn">
          <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200 space-y-4">
            <div className="flex items-center gap-2 border-b border-slate-100 pb-3">
              <SlidersHorizontal className="h-5 w-5 text-slate-900" />
              <h3 className="font-black text-sm text-slate-900 uppercase tracking-tight">Monitorização de Cobranças Globais</h3>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
              <div>
                <label className="block text-[10px] font-black text-slate-400 uppercase mb-1.5">Método de Filtro</label>
                <select
                  value={filterType}
                  onChange={(e) => setFilterType(e.target.value)}
                  className="w-full bg-slate-50 border border-slate-200 text-xs font-bold px-3 py-2.5 rounded-xl focus:outline-none text-slate-800"
                >
                  <option value="vencimento">Por Mês de Vencimento</option>
                  <option value="referencia">Por Mês de Referência</option>
                </select>
              </div>
              <div>
                <label className="block text-[10px] font-black text-slate-400 uppercase mb-1.5">Selecionar Mês</label>
                <select
                  value={activeMonth}
                  onChange={(e) => setActiveMonth(e.target.value)}
                  className="w-full bg-slate-50 border border-slate-200 text-xs font-bold px-3 py-2.5 rounded-xl focus:outline-none text-slate-800"
                >
                  <option value="2026-01">Janeiro</option>
                  <option value="2026-02">Fevereiro</option>
                  <option value="2026-03">Março</option>
                  <option value="2026-04">Abril</option>
                  <option value="2026-05">Maio</option>
                  <option value="2026-06">Junho</option>
                  <option value="2026-07">Julho</option>
                  <option value="2026-08">Agosto</option>
                  <option value="2026-09">Setembro</option>
                  <option value="2026-10">Outubro</option>
                  <option value="2026-11">Novembro</option>
                  <option value="2026-12">Dezembro</option>
                </select>
              </div>
              <div>
                <label className="block text-[10px] font-black text-slate-400 uppercase mb-1.5">Selecionar Ano</label>
                <select disabled className="w-full bg-slate-100 border border-slate-200 text-xs font-bold px-3 py-2.5 rounded-xl cursor-not-allowed text-slate-500">
                  <option value="2026">2026</option>
                </select>
              </div>
              <div>
                <label className="block text-[10px] font-black text-slate-400 uppercase mb-1.5">Estado de Liquidação</label>
                <select
                  value={paymentStatusFilter}
                  onChange={(e) => setPaymentStatusFilter(e.target.value)}
                  className="w-full bg-slate-50 border border-slate-200 text-xs font-bold px-3 py-2.5 rounded-xl focus:outline-none text-slate-800"
                >
                  <option value="Todos">Todas as tranches</option>
                  <option value="Pago">Apenas Pagas</option>
                  <option value="Pendente">Apenas Pendentes</option>
                </select>
              </div>
              <div>
                <label className="block text-[10px] font-black text-slate-400 uppercase mb-1.5">Estado de Faturação *</label>
                <select
                  value={listFaturacaoFilter}
                  onChange={(e) => setListFaturacaoFilter(e.target.value)}
                  className="w-full bg-slate-50 border border-slate-200 text-xs font-bold px-3 py-2.5 rounded-xl focus:outline-none text-slate-800"
                >
                  <option value="Todos">Todas as faturas</option>
                  <option value="Com Fatura">Com Fatura Associada</option>
                  <option value="Falta Fatura">Fatura em Falta</option>
                </select>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200 text-center">
              <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest">Previsto Período</p>
              <p className="text-2xl font-black text-slate-900 mt-2">{totalEsperadoMesFiltrado.toFixed(2)}€</p>
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200 text-center">
              <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest text-emerald-600">Total Validado</p>
              <p className="text-2xl font-black text-emerald-600 mt-2">{totalPagoMesFiltrado.toFixed(2)}€</p>
            </div>
            <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200 text-center bg-rose-50/10 border-rose-100">
              <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest text-rose-500">Falta Cobrar</p>
              <p className="text-2xl font-black text-rose-600 mt-2">{totalFaltaMesFiltrado.toFixed(2)}€</p>
            </div>
          </div>

          <div className="bg-white rounded-3xl shadow-sm border border-slate-200 overflow-hidden">
            <div className="overflow-x-auto">
              <table className="w-full text-left border-collapse text-xs">
                <thead>
                  <tr className="bg-slate-50/70 text-slate-400 uppercase text-[10px] font-black border-b border-slate-200">
                    <th className="px-6 py-4">Apartamento</th>
                    <th className="px-6 py-4">Inquilino (Clica para abrir o Cronograma)</th>
                    <th className="px-6 py-4">Fase</th>
                    <th className="px-6 py-4">Tranche</th>
                    <th className="px-6 py-4 text-right">Devido</th>
                    <th className="px-6 py-4 text-right">Pago</th>
                    <th className="px-6 py-4 text-center">Faturação</th>
                    <th className="px-6 py-4 text-center">Estado</th>
                    <th className="px-6 py-4 text-center">Ações</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100 font-medium text-xs">
                  {filteredReceiptsList.length === 0 ? (
                    <tr>
                      <td colSpan={9} className="px-6 py-12 text-center text-slate-400 font-bold bg-slate-50/20">
                        Nenhum registo de pagamento intermédio coincide com os filtros selecionados.
                      </td>
                    </tr>
                  ) : (
                    filteredReceiptsList.map((receipt) => {
                      const temFatura = !!receipt.refFatura;
                      return (
                        <tr key={receipt.id} className="hover:bg-slate-50/40 transition-colors">
                          <td className="px-6 py-4 font-bold text-indigo-900">{receipt.propriedade}</td>
                          <td className="px-6 py-4">
                            <button
                              onClick={() => focarInquilinoNaTimeline(receipt.stayId)}
                              className="text-slate-900 hover:text-indigo-600 font-black text-left transition-all block hover:underline"
                              title={`Aceder à timeline de ${receipt.inquilino}`}
                            >
                              {receipt.inquilino}
                            </button>
                          </td>
                          <td className="px-6 py-4">
                            <span className="text-[9px] font-black bg-slate-100 text-slate-700 px-2 py-0.5 rounded uppercase">{receipt.fase}</span>
                          </td>
                          <td className="px-6 py-4 text-slate-600 font-semibold">{receipt.titulo}</td>
                          <td className="px-6 py-4 text-right font-black text-slate-900">{receipt.valorDevido.toFixed(2)}€</td>
                          <td className="px-6 py-4 text-right font-black text-emerald-600">{receipt.valorRecebido.toFixed(2)}€</td>
                          <td className="px-6 py-4 text-center">
                            {temFatura ? (
                              <span className="inline-flex items-center gap-1 bg-emerald-50 text-emerald-700 border border-emerald-200 rounded-xl px-2.5 py-1 text-[9px] font-bold font-mono shadow-sm">
                                <FileText size={11} /> {receipt.refFatura}
                              </span>
                            ) : (
                              <span className="inline-flex items-center gap-1 bg-rose-50 text-rose-600 border border-rose-100 rounded-xl px-2.5 py-1 text-[9px] font-black uppercase tracking-wider">
                                Fatura em Falta <span>⚠️</span>
                              </span>
                            )}
                          </td>
                          <td className="px-6 py-4 text-center">
                            <span className={`inline-flex px-3 py-1 rounded-xl text-[9px] font-black uppercase ${receipt.status === "Pago" ? "bg-emerald-50 text-emerald-700 border border-emerald-200" : "bg-rose-50 text-rose-600 border border-rose-100"}`}>
                              {receipt.status}
                            </span>
                          </td>
                          <td className="px-6 py-4 text-center">
                            <button
                              onClick={() => setQuickReceiptData({
                                ...receipt,
                                valorRecebido: receipt.valorRecebido || receipt.valorDevido,
                                dataRecebimento: receipt.dataRecebimento || new Date().toISOString().slice(0, 10),
                                metodo: receipt.metodo || "Transferência",
                                refFatura: receipt.refFatura || "",
                                notas: receipt.notas || "",
                              })}
                              className="bg-slate-950 text-white font-bold px-3 py-1.5 rounded-xl transition-all hover:bg-slate-800 text-[10px] uppercase"
                            >
                              Validar
                            </button>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
